module.exports = __webpack_public_path__ + "img/loan-command.ec856125.svg";